import React, { useContext } from 'react'
import { Flex, Image, Button } from "@chakra-ui/react";
import { Context } from '../../shared/Context/Context';
import Spanish from "../../lang/es.json";
import English from "../../lang/en.json";
import German from "../../lang/de.json";

const LangButtons = (layout) => {

    const {
        lang,
        setLang
    } = useContext(Context);

    return (
        <Flex gap="8px">
            <Button cursor="pointer" transition="all 1s" boxShadow={lang === Spanish && "2px 2px 1px 1px rgba(250, 248, 162, 0.5)"} onClick={() => setLang(Spanish)} overflow="hidden" borderRadius="10px">
                <Image w="50px" src="/assets/montseImages/spain.jpg" />
            </Button>
            <Button cursor="pointer" transition="all 1s" boxShadow={lang === English && "2px 2px 1px 1px rgba(250, 248, 162, 0.5)"} onClick={() => setLang(English)} overflow="hidden" borderRadius="10px">
                <Image w="50px" src="/assets/montseImages/england.jpg" />
            </Button>
            <Button cursor="pointer" transition="all 1s" boxShadow={lang === German && "2px 2px 1px 1px rgba(250, 248, 162, 0.5)"} onClick={() => setLang(German)} overflow="hidden" borderRadius="10px">
                <Image w="50px" src="/assets/montseImages/alemania.jpg" />
            </Button>
        </Flex>
    )
}

export default LangButtons